import React from 'react';
import { Microscope, Camera, Activity, Map, Radio } from 'lucide-react';
import { instituteMock } from '../data/mock';

const iconMap = {
  Microscope,
  Camera,
  Activity,
  Map,
  Radio
};

const Exams = () => {
  const { exams } = instituteMock;

  return (
    <section className="section-padding" id="exams-section">
      <div className="container">
        <div className="exams-header">
          <h2 className="heading-1">{exams.title}</h2>
        </div>
        <div className="grid-product-showcase">
          {exams.items.map((exam, index) => {
            const IconComponent = iconMap[exam.icon];
            return (
              <div key={index} className="exam-card">
                <div className="exam-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="heading-3" style={{ marginBottom: '8px' }}>
                  {exam.name}
                </h3>
                <p className="body-regular text-secondary">
                  {exam.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Exams;
